import { createWebHistory, createRouter } from 'vue-router';
import VideoGenerator from './views/pages/VideoGenerator.vue';
import AnalyticsDashboard from './views/pages/AnalyticsDashboard.vue';
import Catalog from './views/pages/Catalog.vue';

const prefix = (window.I18n?.prefix || '').replace(/\/$/, '');

const router = createRouter({
  history: createWebHistory(prefix ? `/${prefix}` : undefined),
  routes: [
    { path: '/', component: VideoGenerator, name: 'video_generator' },
    { path: '/es', component: VideoGenerator, name: 'video_generator_es', meta: { region: 'us', uiLanguage: 'es' } },
    { path: '/canada', component: VideoGenerator, name: 'video_generator_ca', meta: { region: 'ca' } },
    {
      path: '/canada/fr',
      component: VideoGenerator,
      name: 'video_generator_ca_fr',
      meta: { region: 'ca', uiLanguage: 'fr' }
    },
    { path: '/canada/wfg', component: VideoGenerator, name: 'video_generator_ca_wfg', meta: { region: 'ca', variant: 'wfg' } },
    {
      path: '/canada/wfg/fr',
      component: VideoGenerator,
      name: 'video_generator_ca_wfg_fr',
      meta: { region: 'ca', variant: 'wfg', uiLanguage: 'fr' }
    },
    { path: '/catalog', component: Catalog, name: 'catalog' },
    { path: '/analytics', component: AnalyticsDashboard, name: 'analytics' },
    { path: '/:catchAll(.*)', redirect: { name: 'video_generator' } }
  ]
});

export default router;
